import { jsx as r } from "react/jsx-runtime";
import { aI as a } from "../../../vendor-Dd6qj6gJ.js";
import '../../../assets/index34.css';const o = "_header_115xv_1", d = {
  header: o
};
function c({ children: e }) {
  return /* @__PURE__ */ r(a, { className: d.header, children: e });
}
export {
  c as Header
};
